/**
 * Convert a MISMOIndicator value to a boolean. Returns true if the value is
 * "true" or "1", false otherwise.
 */
export function mismoBool(value) {
  return value === "true" || value === "1";
}
